import React, { useEffect, useState } from 'react'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { Box, Container } from '@mui/material'
import logo from '../../Components/images/logo.png'
import { useParams, useNavigate } from 'react-router-dom'
import { makePostRequest } from 'utils/api'
import CircularProgress from '@mui/material/CircularProgress'
export default function Verify() {
  let navigate = useNavigate()
  let params = useParams()
  const [confirm, setConfirm] = useState(true)

  useEffect(() => {
    verifyEmail()
  }, [])
  const verifyEmail = async () => {
    const response = await makePostRequest('/api/user/mail-code/', { code: params.code }, {}, false)
    if (response.status === 200) {
      setConfirm(false)
    } else {
      //   navigate('/login')
    }
  }
  return (
    // <ThemeProvider theme={defaultTheme}>
    <Container component="main" maxWidth="xs">
      {/* <CssBaseline /> */}

      <Box
        sx={{
          pt: 15,
          pb: 30,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          color: 'white',
        }}
      >
        {/* <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
        <LockOutlinedIcon />
      </Avatar> */}
        <Box sx={{ mb: 5 }}>
          <img src={logo} alt="" />{' '}
        </Box>
        {confirm ? (
          <Box sx={{ display: 'flex', mt: 10 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box
            display={'flex'}
            justifyContent={'center'}
            flexDirection={'column'}
            alignItems={'center'}
            mt={4}
          >
            <Box sx={{ mb: 5 }}>
              <CheckCircleOutlineIcon sx={{ fontSize: 80 }} />
            </Box>
            <Box component={'h3'} mb={5}>
              Toutes nos félicitations!
            </Box>
            <Box sx={{ fontWeight: '700', fontSize: 14, textAlign: 'center', mb: 3 }}>
              Vous avez vérifié avec succès une adresse e-mail. Vous pouvez maintenant vous
              connecter à l'application.
            </Box>

            <Box
              onClick={() => {
                navigate('/login')
              }}
              mt={1}
              sx={{ color: '#6ea5f7', textDecoration: 'underline', cursor: 'pointer' }}
            >
              Se connecter{' '}
            </Box>
          </Box>
        )}
      </Box>
      {/* <Copyright sx={{ mt: 5 }} /> */}
    </Container>
    // </ThemeProvider>
  )
}
